import { useContext } from 'react';
import { MessageContext } from '../module/MessageContext';

export const useMessageContext = () => {
    return useContext(MessageContext);
};
